export const ROVER_PROD_HOSTS = /^(www\.)?rover\.com$/;
export const ROVER_PR_STAGING_HOSTS = /^staging-pr-([-a-zA-Z0-9.]+)?roverstaging\.com$/;
export const ROVER_PR_WEBAPP_STAGING_HOSTS =
  /^staging-pr-([-a-zA-Z0-9.]+)?\.webapp\.roverstaging\.com$/;
export const ROVER_STAGING_HOSTS = /^([-a-zA-Z0-9.]+)?roverstaging\.com$/;
export const ROVER_DEV_HOSTS = /^((rover.local)|(nginx))$/;
export const ROVER_HOSTS = new RegExp(
  [ROVER_PROD_HOSTS.source, ROVER_STAGING_HOSTS.source, ROVER_DEV_HOSTS.source].join('|')
);

export const CAT_IN_A_FLAT_PROD_HOSTS = /^(www\.)?catinaflat\.com$/;
export const CAT_IN_A_FLAT_HOSTS = new RegExp([CAT_IN_A_FLAT_PROD_HOSTS.source].join('|'));
